import React from "react";
import Grid from "@mui/material/Grid";
import Badge from "@mui/material/Badge";
import Tooltip from "@mui/material/Tooltip";
import { makeStyles, styled } from "@mui/material/styles";
import Zoom from "@mui/material/Zoom";

const PREFIX = 'Icon';

const classes = {
  icon: `${PREFIX}-icon`,
  conversions: `${PREFIX}-conversions`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  width: "1.5rem",
  height: "2rem",
  marginRight: "1rem",
  [`& .${classes.icon}`]: {
    height: 24,
    filter: "invert(50%)",
    cursor: "pointer",
  },

  [`& .${classes.conversions}`]: {
    cursor: "pointer",
    zIndex:2,
  }
}));

export default (props) => {
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = (event) => {
    event.stopPropagation();
    setOpen(false);
  };

  const handleTooltipOpen = (event) => {
    event.stopPropagation();
    setOpen(true);
    if (event.type === "click" && props.fetchConversions) {
      props.fetchConversions();
    }
  };

  if (props.qty > 0 || props.qty === "T") {
    return (
      (<Root>
        {!!props?.display || (
          <Grid item>
            <Tooltip
              title={props.alt}
              arrow
              onClose={handleTooltipClose}
              open={open}
              TransitionComponent={Zoom}
            >
              <Badge
                badgeContent={props.qty === "T" ? 0 : props.qty}
                color={"primary"}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                onClick={handleTooltipOpen}
                onMouseOver={handleTooltipOpen}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/assets/icons/${props.icon}.svg`}
                  alt={props.alt}
                  className={classes.icon}
                />
              </Badge>
            </Tooltip>
          </Grid>
        )}
        {!!props?.display && (
          <Tooltip
            title={props.alt}
            arrow
            onClose={handleTooltipClose}
            open={open}
            TransitionComponent={Zoom}
          >
            <Badge
              badgeContent={props.qty === "T" ? 0 : props.qty}
              color={!!props.display ? "error" : "primary"}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              onClick={handleTooltipOpen}
              onMouseOver={handleTooltipOpen}
              className={classes.conversions}
              max={9999}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/icons/${props.icon}.svg`}
                alt={props.alt}
                className={classes.icon}
              />
            </Badge>
          </Tooltip>
        )}
      </Root>)
    );
  }
  return null;
};
